import * as React from "react";
import { useHistory } from "react-router-dom";
import { List, ListItem, Title3, Text, makeStyles, tokens } from "@fluentui/react-components";
import { iconRegularClassName, MathFormulaRegular } from "@fluentui/react-icons";

import { PATHS } from "../components/routes/paths";
import { FUNC_NAMESPACE } from "../../functions/functions-extra-metadata";
import { backgroundColorSeaGreen, backgroundColorSeaGreenHover, usePageStyles } from "../styles/styles";
import { ThemeContext } from "../store/theme-context-api";
import { CUSTOM_FUNCTION_NAMES } from "../../functions/functions-metadata";

const useStyles = makeStyles({
  onHoverDark: {
    ":hover": {
      backgroundColor: backgroundColorSeaGreenHover,
    },
  },

  onHoverLight: {
    ":hover": {
      backgroundColor: backgroundColorSeaGreen,
      color: tokens.colorNeutralBackground2,
      boxShadow: tokens.shadow16,
      [`& .${iconRegularClassName}`]: {
        color: tokens.colorNeutralBackground2,
      },
    },
  },
});

export default function DocPage() {
  const { isDarkTheme } = React.useContext(ThemeContext);
  const history = useHistory();
  const pageStyles = usePageStyles();
  const styles = useStyles();

  return (
    <div className={pageStyles.container}>
      <Title3>FUNCTIONS</Title3>
      <List navigationMode="items">
        {CUSTOM_FUNCTION_NAMES.map((funcName) => {
          return (
            <ListItem
              className={isDarkTheme ? styles.onHoverDark : styles.onHoverLight}
              key={funcName}
              aria-label={funcName}
              onAction={() => {
                history.push(`${PATHS.DOCS_PAGE}/${funcName}`);
              }}
            >
              <div className="flex py-[1em] w-full border-b gap-[5px] items-center">
                <MathFormulaRegular></MathFormulaRegular>
                <Text>{`${FUNC_NAMESPACE}.${funcName}`}</Text>
              </div>
            </ListItem>
          );
        })}
      </List>
    </div>
  );
}
